import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CCFree icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CCFree } from '@sravni/design-system-icons'
 *
 * <CCFree />
 * ```
 */
var CCFree = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CCFree", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.903 17.5a4.166 4.166 0 0 1-4.167-4.166c0-2.254 1.917-4.169 4.171-4.167a4.166 4.166 0 0 1-.004 8.333ZM2.402 5.708h15.834", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M18.236 10.833V4.167c0-.921-.746-1.667-1.667-1.667h-12.5c-.92 0-1.667.746-1.667 1.667v7.5c0 .92.746 1.666 1.667 1.666h6.667M16.754 12.408l-2.315 2.315-1.388-1.39", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CCFree };
//# sourceMappingURL=CCFree.js.map
